{
  "page": {
    "intro": "What is really in the shop and the vault, per place, state and owner. Stock never changes by typing a number — every change asks for a reason.",
    "receive": "Receive stock",
    "tabs": "How to look at the stock",
    "tab_levels": "By product and place",
    "tab_cards": "Card by card",
    "levels_hint": "Tap a row to see its history and change the stock. Single cards open the card list.",
    "cards_hint": "One row per card. Tap a card to see its history, take it off sale or mark it lost / damaged.",
    "one_product": "Showing one product only.",
    "show_all": "Show all"
  },
  "states": {
    "draft": "Not on sale yet",
    "available": "On sale",
    "held": "Held (someone is buying)",
    "reserved": "Reserved (payment on its way)",
    "sold": "Sold",
    "fulfilled": "Sent / handed over",
    "returned": "Returned — to check",
    "withdrawn": "Taken off sale",
    "consignment_returned": "Given back to consignor",
    "lost": "Lost",
    "damaged": "Damaged"
  },
  "owner": {
    "shop": "Shop",
    "consignor": "Consigned",
    "mixed": "Shop + consigned"
  },
  "columns": {
    "title": "Product",
    "code": "Product code",
    "condition": "Condition",
    "state": "State",
    "location": "Place",
    "owner": "Whose",
    "hold": "Held until",
    "cost": "Purchase price",
    "agreed_price": "Agreed price (consigned)",
    "received_at": "Arrived",
    "listed_at": "On sale since",
    "sold_at": "Sold on",
    "updated": "Last change"
  },
  "levels": {
    "on_hand": "On the shelf",
    "reserved": "Held / reserved",
    "unsellable": "Waiting for a check",
    "available": "Can be sold",
    "incoming": "On the way",
    "holds": "Holds"
  },
  "filters": {
    "code": "Product code",
    "sold_out": "Sold out",
    "has_hold": "Has a hold",
    "kind": "Kind",
    "on_hold": "Held or reserved (with time left)",
    "age": "Waiting",
    "age_90": "More than 90 days"
  },
  "views": {
    "sold_out": "Sold out",
    "with_holds": "With holds",
    "sealed": "Sealed products",
    "on_hold": "Held / reserved",
    "consigned_not_listed": "Consigned, not on sale yet",
    "old": "Waiting more than 90 days",
    "returned": "Returned — to check"
  },
  "age": {
    "days_one": "{{count}} day",
    "days_other": "{{count}} days"
  },
  "holds": {
    "expired": "Time is up",
    "in_minutes": "{{time}} left",
    "in_hours": "{{h}} h {{m}} min left",
    "in_days": "{{d}} days {{h}} h left",
    "no_expiry": "No end time",
    "see_card": "Open the card to see",
    "intro": "Cards and boxes kept for someone — a web checkout, a register, a customer by chat. Let one go to put it back on sale.",
    "empty": "Nothing is kept right now.",
    "owner": {
      "cart": "Web cart",
      "checkout": "Web checkout",
      "order": "Order",
      "pos_order": "Register sale",
      "register": "Register",
      "live_show": "Live show",
      "staff": "Kept by staff",
      "channel_order": "Marketplace order",
      "other": "Other"
    },
    "columns": {
      "type": "Kind",
      "item": "Item",
      "owner": "Kept for",
      "qty": "Pieces",
      "created": "Since",
      "expires": "Time left",
      "actions": "What to do"
    },
    "release": "Let go",
    "release_title": "Let this hold go?",
    "release_consequence": "{{title}} goes back on sale everywhere at once.",
    "release_why": "Why?",
    "release_reasons": {
      "customer_cancelled": "The customer does not want it",
      "customer_no_show": "The customer did not come",
      "wrong_item": "Wrong item kept",
      "stuck": "The hold is stuck",
      "other": "Other"
    },
    "release_note": "A few words (for the history)",
    "release_reason_required": "Choose why the hold is let go.",
    "release_note_required": "Write a few words for “Other”.",
    "released": "{{title}} is back on sale",
    "released_hint": "Every screen and the web shop show it for sale again.",
    "filters": {
      "q": "Search",
      "q_placeholder": "Name or item code",
      "expiring": "Ends within 10 minutes",
      "older": "Kept for longer than",
      "older_24": "1 day"
    },
    "views": {
      "expiring": "Ending soon",
      "old": "Kept more than a day",
      "manual": "Kept by staff"
    },
    "manual": {
      "open": "Keep a card for a customer",
      "title": "Keep an item for a customer",
      "description": "The item stops being sold everywhere until the time is up or someone lets it go.",
      "confirm": "Keep it",
      "item": "Scan or search the item",
      "item_hint": "Item code, card label, barcode or name.",
      "change_item": "Choose another item",
      "no_card": "This card is not on sale right now — it cannot be kept.",
      "qty": "How many",
      "reason": "Why?",
      "reasons": {
        "chat_customer": "A customer asked by chat",
        "phone_order": "A customer asked by phone",
        "event": "For an event",
        "other": "Other"
      },
      "note": "For whom / a few words",
      "note_hint": "e.g. Tanaka-san (LINE), comes on Saturday",
      "how_long": "How long",
      "durations": {
        "3600": "1 hour",
        "86400": "1 day",
        "259200": "3 days",
        "604800": "7 days"
      },
      "done": "{{title}} is kept",
      "problem": {
        "item": "Choose the item first.",
        "reason": "Choose why.",
        "note": "Write for whom it is kept.",
        "qty": "At least 1 piece."
      }
    }
  },
  "hold_types": {
    "cart": "In a cart",
    "checkout": "Paying online",
    "pos_hold": "At the register",
    "live_show": "Live show",
    "channel_pending": "Sold elsewhere, being paid",
    "layaway": "Layaway",
    "manual": "Kept by staff"
  },
  "unit": {
    "title": "Card",
    "cert": "Cert",
    "on_hold": "This card is held.",
    "open_hold": "See the hold",
    "history": "What happened to this card",
    "no_history": "Nothing yet.",
    "movements": "Stock history",
    "all_movements": "Full history",
    "withdraw": "Take off sale",
    "withdraw_title": "Take this card off sale?",
    "withdraw_consequence": "It disappears from the web shop and the register until you put it back.",
    "withdraw_done": "Taken off sale",
    "republish": "Put back on sale",
    "republish_title": "Put this card back on sale?",
    "republish_consequence": "It can be bought on the web shop and at the register again.",
    "republish_done": "Back on sale",
    "write_off": "Mark lost / damaged",
    "return_to_consignor": "Give back to the consignor"
  },
  "reasons_text": {
    "received": "arrived",
    "published": "put on sale",
    "hold_created": "held",
    "hold_released": "hold ended",
    "hold_expired": "hold time was up",
    "sold": "sold",
    "fulfilled": "sent",
    "returned": "returned",
    "staff_decision": "staff decision",
    "mark_lost": "marked lost",
    "mark_damaged": "marked damaged",
    "transfer_shipped": "sent to another place",
    "transfer_received": "arrived from another place"
  },
  "adjust": {
    "open": "Change stock",
    "title_unit": "Mark this card lost or damaged",
    "title_level": "Change the stock",
    "unit_hint": "A single card is never “−1”: it is marked as lost or damaged and leaves the shop's stock.",
    "what_happened": "What happened",
    "write_off": {
      "lost": "Lost (cannot be found)",
      "damaged": "Damaged (cannot be sold)"
    },
    "confirm": "Save the change",
    "confirm_lost": "Mark as lost",
    "confirm_damaged": "Mark as damaged",
    "done_lost": "“{{title}}” marked as lost",
    "done_damaged": "“{{title}}” marked as damaged",
    "done_level": "“{{title}}”: {{from}} → {{to}}",
    "qty": "Pieces to add (+) or remove (−)",
    "minus": "One less",
    "plus": "One more",
    "preview": "{{place}}: {{from}} → {{to}} on the shelf",
    "type": "Kind of change",
    "types": {
      "adjustment": "Correction",
      "damage": "Damaged pieces",
      "lost": "Lost pieces"
    },
    "reason": "Why",
    "reasons": {
      "miscount": "Counted wrong",
      "found": "Found again",
      "damaged": "Damaged",
      "lost": "Lost",
      "theft": "Stolen",
      "sample": "Used as a sample",
      "other": "Something else"
    },
    "note": "A few words",
    "note_hint": "Helps later when someone reads the history.",
    "problems": {
      "reason_required": "Say why in a few words (for example: counted wrong).",
      "note_required": "Write what happened.",
      "qty_zero": "Choose how many pieces (not 0).",
      "below_zero": "The shelf cannot go below 0."
    }
  },
  "drift": {
    "title_one": "The stock numbers do not match the history for {{count}} product",
    "title_other": "The stock numbers do not match the history for {{count}} products",
    "how_to_fix": "How to fix",
    "hide": "Hide",
    "expected_actual": "Should be {{expected}}, the counter says {{actual}}"
  },
  "movement_types": {
    "receipt": "Received",
    "purchase": "Bought",
    "consignment_intake": "Consigned in",
    "consignment_return": "Given back to consignor",
    "sale": "Sold",
    "return": "Returned",
    "adjustment": "Correction",
    "transfer_out": "Sent to another place",
    "transfer_in": "Arrived from another place",
    "damage": "Damaged",
    "lost": "Lost",
    "count": "Stock count",
    "buylist_intake": "Bought from a customer"
  },
  "references": {
    "order": "Web order",
    "pos_order": "Register sale",
    "channel_order": "Other shop order",
    "consignment_item": "Consigned card",
    "buylist_intake": "Bought from a customer",
    "stock_transfer": "Transfer",
    "stock_count": "Stock count",
    "adjustment": "Correction",
    "live_show": "Live show",
    "receipt": "Receipt",
    "purchase": "Purchase",
    "hold": "Hold",
    "catalog": "Product change",
    "manual": "By hand",
    "order_return": "Return of an order",
    "pos_return": "Return at the register",
    "order_cancel": "Cancelled order",
    "oversell_conflict": "Sold twice — decision"
  },
  "actors": {
    "staff": "Staff",
    "system": "The system",
    "pos_device": "Register",
    "service": "The system"
  },
  "movements": {
    "intro": "Every change of stock, newest first. The history cannot be edited.",
    "counted_item": "Counted item",
    "columns": {
      "when": "When",
      "product": "Product",
      "type": "What",
      "delta": "Change",
      "after": "On the shelf after",
      "reference": "Because of",
      "actor": "By"
    },
    "filters": {
      "code": "Product",
      "code_placeholder": "Product code, JAN or cert number",
      "dates": "Dates",
      "actor": "Staff member (id)"
    }
  },
  "receive": {
    "intro": "Choose the place, scan the items one after the other (Enter adds them), then press “Receive”.",
    "form_label": "Receive stock",
    "consigned_note": "Consigned cards are received at the consignment counter (identity check and 古物台帳 happen there).",
    "consigned_link": "Open consignment",
    "location": "Put into",
    "reference_type": "Where it comes from",
    "reference_purchase": "Bought from a supplier",
    "reference_manual": "Other",
    "reference_id": "Slip / invoice number",
    "reference_id_hint": "Optional — helps to find it later.",
    "scan": "Scan or type the product",
    "scan_hint": "Product code, JAN barcode or cert number + Enter. Ctrl/⌘ + Enter = Receive.",
    "added": "Added: {{title}}",
    "duplicate_card": "{{code}} is already in the list — a single card is always 1 piece.",
    "empty": "Nothing scanned yet",
    "empty_hint": "Scan the first item — the box keeps the focus for the next one.",
    "lines": "Items to receive",
    "qty": "Pieces",
    "qty_of": "Pieces of {{title}}",
    "single_hint": "A single card is 1 piece",
    "cost": "Purchase price (each)",
    "cost_of": "Purchase price of {{title}}",
    "remove": "Remove {{title}}",
    "note": "Note",
    "summary": "{{lines}} lines · {{pieces}} pieces",
    "submit": "Receive",
    "done": "Received: {{lines}} lines, {{pieces}} pieces",
    "no_lines": "Scan at least one item first.",
    "no_location": "Choose where the items go.",
    "recent": "Received recently",
    "no_receipts": "Nothing received yet.",
    "receipt_title": "Receipt",
    "receipt_missing": "This receipt was not found.",
    "pieces_one": "{{count}} piece",
    "pieces_other": "{{count}} pieces"
  },
  "scan": {
    "hint": "Scan or type a code and press Enter; or type a name and choose.",
    "looking": "Looking for the code…",
    "not_found": "No product has the code “{{code}}”.",
    "lookup_failed": "The code could not be checked — check the connection.",
    "camera_open": "Use the camera",
    "camera_close": "Close the camera",
    "camera_on": "Point the camera at the barcode",
    "camera_failed": "The camera could not be opened. Allow the camera in the browser, or use the scanner."
  },
  "locations": {
    "intro": "Shops and warehouses of the stock. A place can be switched off only when nothing is left in it.",
    "add": "Add a place",
    "new_title": "New place",
    "drawer_hint": "Where stock is kept. Online orders ship from the places marked for it.",
    "save": "Save place",
    "saved": "{{code}} saved",
    "duplicate": "This code is already used by another place.",
    "activate": "Use again",
    "activate_title": "Use {{code}} again?",
    "activate_consequence": "It can receive stock again.",
    "activated": "{{code}} is used again",
    "deactivate": "Stop using",
    "deactivate_title": "Stop using {{code}}?",
    "deactivate_consequence": "It is hidden from the lists. Its history stays.",
    "deactivated": "{{code}} is no longer used",
    "checking_stock": "Checking what is still there…",
    "cannot_deactivate": "This place still has stock",
    "has_stock": "{{count}} piece(s) are still here. Move them to another place (Transfers) first.",
    "has_stock_many": "At least {{count}} pieces are still here. Move them to another place (Transfers) first.",
    "is_default": "This is the main place. Make another place the main one first.",
    "ok": "OK",
    "in_use": "In use",
    "not_in_use": "Not used",
    "columns": {
      "name": "Name",
      "use": "Used for",
      "active": "In use"
    },
    "fields": {
      "code": "Code",
      "code_hint": "Capital letters, numbers and -, e.g. TOKYO-STORE.",
      "code_locked": "The code cannot change (labels and history use it).",
      "name_en": "Name (English)",
      "name_ja": "Name (Japanese)",
      "name_th": "Name (Thai)",
      "type": "Kind of place",
      "address": "Address",
      "phone": "Phone"
    },
    "address": {
      "postal_code": "Postal code",
      "prefecture": "Prefecture",
      "city": "City / ward",
      "address1": "Street and number",
      "address2": "Building / floor"
    },
    "types": {
      "store": "Shop",
      "warehouse": "Warehouse",
      "vault": "Safe / vault",
      "virtual": "Not a real place"
    },
    "flags": {
      "fulfillsOnline": "Ships online orders",
      "fulfillsOnline_hint": "Web orders can be packed from here.",
      "pickupEnabled": "Customers can pick up here",
      "pickupEnabled_hint": "Shown as a pick-up choice at checkout.",
      "isDefault": "Main place",
      "isDefault_hint": "Received stock and new cards go here unless another place is chosen."
    },
    "problems": {
      "required": "Please fill this in.",
      "code_format": "Use capital letters A–Z, numbers and - (2–32 characters, starting with a letter)."
    }
  },
  "transfers": {
    "intro": "Move stock between the shop and the vault in two steps: send (it is “on the way”), then receive by scanning.",
    "new": "New transfer",
    "status_filter": "Show",
    "status": {
      "draft": "Draft",
      "in_transit": "On the way",
      "received": "Received",
      "cancelled": "Cancelled"
    },
    "empty": "No transfers yet",
    "empty_hint": "“New transfer” moves stock to another place.",
    "to": "to",
    "pieces_one": "{{count}} piece",
    "pieces_other": "{{count}} pieces",
    "has_missing": "Something is missing",
    "title_of": "Transfer {{from}} → {{to}}",
    "from": "From",
    "to_label": "To",
    "same_location": "Choose two different places.",
    "scan": "Scan or type what goes",
    "scan_hint": "Cards by their label code, boxes / packs by JAN (each scan = 1 more).",
    "duplicate": "{{code}} is already in the list.",
    "no_lines": "Nothing in this transfer yet",
    "no_lines_hint": "Scan the first item.",
    "lines": "Items",
    "note": "Note",
    "save_draft": "Save as draft",
    "saved": "Transfer saved",
    "ship": "Send now",
    "ship_title": "Send this transfer?",
    "ship_consequence": "{{count}} piece(s) leave {{from}} now and wait “on the way” until they are received at {{to}}. They cannot be sold meanwhile.",
    "shipped": "Sent: {{count}} piece(s) on the way",
    "shipped_at": "Sent",
    "received_at": "received",
    "cancel": "Cancel transfer",
    "cancel_title": "Cancel this transfer?",
    "cancel_consequence": "Nothing moves; the draft is closed.",
    "print": "Print the transfer slip",
    "receive": "Receive (scan)",
    "receive_title": "Receive at {{to}}",
    "receive_intro": "Scan every card and box as it comes out. Green = arrived.",
    "not_in_transit": "This transfer is not on the way.",
    "receive_progress": "{{done}} / {{total}} arrived",
    "scan_in": "Scan what arrived",
    "scan_result": {
      "card": "Arrived: {{title}}",
      "counted": "Arrived: {{title}} ({{total}})",
      "duplicate": "Already scanned: {{title}}",
      "too_many": "More than was sent: {{title}}",
      "not_in_transfer": "Not part of this transfer: {{title}}"
    },
    "arrived": "Arrived",
    "waiting": "Not scanned yet",
    "sent": "Sent",
    "difference": "Difference",
    "save_progress": "Save what arrived so far",
    "progress_saved": "Saved — you can continue later",
    "finish": "Finish receiving",
    "missing_title_one": "{{count}} piece did not arrive",
    "missing_title_other": "{{count}} pieces did not arrive",
    "missing_consequence": "They stay as a difference. Search once more — or confirm them as lost afterwards.",
    "missing_reason": "What happened",
    "missing_reason_hint": "For example: not in the bag.",
    "finish_anyway": "Finish with the difference",
    "received_done": "Transfer received",
    "missing_one": "{{count}} missing",
    "missing_other": "{{count}} missing",
    "confirmed_lost_one": "{{count}} confirmed lost",
    "confirmed_lost_other": "{{count}} confirmed lost",
    "confirm_lost": "Confirm lost",
    "confirm_lost_title": "Confirm as lost?",
    "confirm_lost_consequence": "{{count}} × {{title}} leave the stock as lost (it shows in the history).",
    "lost_confirmed": "Confirmed as lost"
  },
  "counts": {
    "intro": "Count the stock of one place with the scanner or the camera. Selling continues while you count.",
    "start": "Start a count",
    "start_title": "Start a count",
    "start_hint": "The system remembers what should be there now; then you scan everything you find.",
    "scope": "What to count",
    "scope_all": "Everything at this place",
    "scope_productType": "Only some kinds",
    "shelf": "Shelf / box (optional)",
    "shelf_hint": "For your own notes, e.g. “Showcase 2”.",
    "note": "Note",
    "status_filter": "Show",
    "status": {
      "open": "Started",
      "counting": "Counting",
      "review": "Checking differences",
      "closed": "Closed",
      "cancelled": "Cancelled"
    },
    "empty": "No counts yet",
    "empty_hint": "“Start a count” — then scan everything on the shelf.",
    "scan_title": "Counting",
    "leave_scan": "Leave",
    "not_editable": "This count is finished — scanning is closed.",
    "progress": "Counted {{counted}} / {{expected}}",
    "scan_label": "Scan",
    "scan_hint": "The box keeps the focus — just keep scanning. Enter after typing a code by hand.",
    "feedback": {
      "none": "Scan the first item.",
      "card": "Counted",
      "sealed": "Counted ({{total}})",
      "duplicate": "Already counted — this card was scanned before",
      "unresolved": "Checking this code…"
    },
    "offline_one": "No connection — {{count}} scan is kept on this tablet and sent later",
    "offline_other": "No connection — {{count}} scans are kept on this tablet and sent later",
    "sending_one": "Sending {{count}} scan…",
    "sending_other": "Sending {{count}} scans…",
    "all_sent": "Everything is saved",
    "unknown_title_one": "{{count}} code is not a product of the shop",
    "unknown_title_other": "{{count}} codes are not products of the shop",
    "unknown_hint": "Put these aside and look them up later.",
    "missing_title_one": "Not found yet: {{count}}",
    "missing_title_other": "Not found yet: {{count}}",
    "of_expected": "{{counted}} of {{expected}}",
    "still_sending": "Some scans are still being sent. Wait a moment and try again.",
    "finish_scan": "Finish counting",
    "summary_title": "Count at {{place}}",
    "continue_scan": "Continue scanning",
    "totals": {
      "expected": "Should be there",
      "counted": "Counted",
      "variance_lines": "Lines with a difference",
      "moved": "Moved while counting"
    },
    "variance_value": "Value of the differences:",
    "threshold": "manager needed above",
    "review": "Check the differences",
    "cancel": "Cancel this count",
    "cancel_title": "Cancel this count?",
    "cancel_consequence": "Nothing in the stock changes; the scans are dropped.",
    "differences_one": "{{count}} difference",
    "differences_other": "{{count}} differences",
    "no_differences": "Everything matches — closing changes nothing.",
    "expected": "Should be",
    "counted": "Counted",
    "difference": "Difference",
    "value": "Value",
    "apply": "Adjust",
    "apply_line": "Adjust {{title}}",
    "reason_of": "Reason for {{title}}",
    "result": "Result",
    "moved_after": "Sold or moved while counting — check it",
    "resolution": {
      "pending": "Waiting",
      "no_variance": "Matches",
      "adjusted": "Stock adjusted",
      "rejected": "Not adjusted",
      "skipped_moved": "Skipped (moved)"
    },
    "needs_manager": "The differences are worth more than the shop's limit — a manager has to close this count.",
    "close": "Close and adjust stock",
    "close_title": "Close the count and adjust the stock?",
    "close_consequence_one": "{{count}} difference becomes a stock correction (it shows in the history).",
    "close_consequence_other": "{{count}} differences become stock corrections (they show in the history).",
    "close_note": "Reason",
    "close_note_hint": "Saved with every correction.",
    "default_note": "Stock count",
    "closed_done_one": "Count closed — {{count}} correction",
    "closed_done_other": "Count closed — {{count}} corrections",
    "back_to_scan": "Back to scanning",
    "see_movements": "See the corrections in the stock history"
  }
}
